import { CreateSingleton, Items, RecordCreate, RecordMap } from "@pdfking/tfunc"

import type { DispatchLibrary } from "#public"
import type { I18nNames } from "#public"
import type { LibraryType } from "#public"

import { FormatTemplate } from "../../internal/FormatTemplate"

export const LibraryFromJson = <T extends Record<string, { enum: string }>, Lang extends string>(
  lib: LibraryType<T, Lang>
): DispatchLibrary<{ [K in keyof T]: I18nNames<T[K]> }, Lang> =>
  RecordCreate(
    Items(lib).map(([key, langs]) => [
      key,
      RecordCreate(
        Items(langs as Record<string, () => Promise<{ default: Record<string, string> }>>).map(
          ([lang, loader]) => [
            lang,
            CreateSingleton(() =>
              loader().then(
                m =>
                  RecordMap(
                    v => (ctx?: Record<string, unknown>) => (ctx ? FormatTemplate(v, ctx) : v),
                    m.default
                  ) as I18nNames<T[keyof T]>
              )
            ),
          ]
        )
      ),
    ])
  ) as DispatchLibrary<{ [K in keyof T]: I18nNames<T[K]> }, Lang>
